import React from 'react';
import { useEffect, useRef, useState  } from 'react';
import { Button, Grid, GridColumn, GridRow, Label, Icon} from 'semantic-ui-react'
import { useHistory, withRouter } from "react-router";
import './TermsOfService.less'
import { uploadSignatureImage, getSellerInfo as _getSellerInfo } from '../../services/Seller';
import logo from '../../assets/images/newui/dealgrace_logo.png'
import { Form } from 'formsy-semantic-ui-react';
import moment from 'moment';
const _ = require('lodash');
const tosStatusConstant = require('../../constants/tosStatus');
import { Dimmer, Loader } from 'semantic-ui-react';
import SignaturePad from 'signature_pad';
import { setTOSSigned } from '../../store/actions/seller';
import { connect, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';

const TermsOfService = (props) =>{
    
    const formRef = useRef(null);
    //console.log(props.match.params.category);
    const categorySEOName = props.match.params.category;
    const [imageURL, setImageURL] = useState(null);
    const [sellerID, setSellerID] = useState(0);
    const [sellerName, setSellerName] = useState('');
    const [subscriptionID, setSubscriptionID] = useState(0);
    const [price, setPrice] = useState(0);
    const [commission, setCommission] = useState(0);
    const [referralFee, setReferralFee] = useState(0);
    const [sellerAddress, setSellerAddress] = useState('')
    const [signatureImage, setSignatureImage] = useState({});
    const [isReadOnly, setIsReadOnly] = useState(false);
    const [signatureID, setSignatureID] = useState(0);
    const [sellerContactName, setSellerContactName] = useState('');
    const [brandingImageURL, setBrandingImageURL] = useState('');
    const [brandingName, setBrandingName] = useState('');
    const [brandingSignatureImageURL, setBrandingSignatureImageURL] = useState('');
    const [companySignatureName, setCompanySignatureName] = useState('');
    const [tosStatus, setTOSStatus] = useState(0);
    const [createdAt, setCreatedAt] = useState('');
    const [sellerProfilePublish, setSellerProfilePublish] = useState('');
    //const [signedAt, setSignedAt] = useState('');
    //const [imageID, setImageID] = useState(0);
   const [showLoader, setLoader] = useState(false);
   const [sellerUserName, setSellerUserName] = useState('');
   const [sigPad, setSigPad] = useState(null);
   const isTOSEnabled = useSelector(({ reducer }) => reducer.isTOSEnabled);

    let signaturePad = {};
    useEffect(async() => {
        if(isTOSEnabled)
        {
            await getSellerInfo();
        
            const canvas = document.querySelector("canvas");
            if (canvas) {
                signaturePad = new SignaturePad(canvas);
    
                setSigPad(signaturePad);
    
                window.addEventListener('resize', updateWindowDimensions);
    
                const companySignature = document.querySelector(".company-signature");
    
                canvas.width = companySignature.clientWidth - 35;
                canvas.height = companySignature.clientHeight;
                canvas.oncontextmenu = () => { return false };
            }
        }else
        {
            props.history.push('/');
        }

    }, [])
    

    const updateWindowDimensions = () => {
        if (!isReadOnly) {
            //const data = signaturePad.toData();
            const canvas = document.querySelector("canvas");
            const companySignature = document.querySelector(".company-signature");
            if (companySignature && canvas) {
                canvas.width = companySignature.clientWidth - 35;
                canvas.height = companySignature.clientHeight;
            }
            // signaturePad.width = companySignature.clientWidth - 35;
            // signaturePad.height = companySignature.clientHeight;
            // signaturePad.fromData(data);
        }
    }


    const getSellerInfo = async () =>{
        
        const res = await _getSellerInfo(categorySEOName);
        if(res.resStatus == 200)
        {
            
            const { data } = res;
            if(_.isEmpty(data) || !data.signatureID)
            {
                props.history.push('/');
            }
            setSellerID(data.sellerID);
            setSellerName(data.sellerName);
            setSubscriptionID(data.sellerSubID);
            setPrice(data.price);
            setCommission(data.commission);
            setReferralFee(data.referralFee);
            setSellerAddress(data.addressline1);
            setSignatureImage(data.image);
            setSignatureID(data.signatureID);
            setSellerContactName(data.name);
            !_.isEmpty(data.brandingInfo) ? setBrandingName(data.brandingInfo.brandingName) : setBrandingName('Towgrace');
            (!_.isEmpty(data.brandingInfo) && !_.isEmpty(data.brandingInfo.brandingImage) && !_.isEmpty(data.brandingInfo.brandingImage.URL) ) ? setBrandingImageURL(data.brandingInfo.brandingImage.URL) : setBrandingImageURL(logo);
            setBrandingSignatureImageURL(data?.brandingInfo?.brandingSignatureImage?.URL);
            setCompanySignatureName(data?.tosConfiguration?.signatureName);
            setSellerProfilePublish(data?.sellerProfilePublishConfiguration?.email);
            setTOSStatus(data.tosStatus);
            setCreatedAt(moment(data.tosCreatedAt).format("MMM DD, YYYY"));
            setSellerUserName(data.firstName + (_.isEmpty(data.lastName) ? '' : ' ' + data.lastName));

            ((data.tosStatus == tosStatusConstant.APPROVED.id || data.tosStatus == tosStatusConstant.SIGNED.id) && !_.isEmpty(data.image.URL)) ? setIsReadOnly(true) : setIsReadOnly(false);
        }
        
    }

    const clear = () => {
        sigPad.clear();
    }

    function dataURLtoFile(dataurl, filename) {
        var arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], filename, { type: mime });
    }
    
    const onSubmit = (form) => {
        if (sigPad.isEmpty()) {
            
        }
        else {
            displayLoader();
            const imgUrl = sigPad.toDataURL('image/png');
            let file = dataURLtoFile(imgUrl, sellerID + "-signature.png");
            let formData = new FormData();
            formData.append("image", file);
            formData.append("catSEOName", categorySEOName);
            formData.append("name", _.isEmpty(form.sellerContactName) ? sellerUserName : form.sellerContactName);
            try {
                uploadSignatureImage(formData).then(res => {
                    if (res.status == 'success') {
                        props.setTOSSigned(true);
                        props.history.push('/');
                        
                    }
                    
                })
            }
            catch (err) {
                console.log(err);
            }
            finally {
               hideLoader();
            }
        }
    }

    const loadSignatureControl=()=>{

    }

    const displayLoader = () => {
        window.scrollTo({
            top: 0,
            behavior: 'auto'
        });
        document.body.style.overflowY = 'hidden'
        setLoader(true);
    }

    const hideLoader = () => {
        document.body.style.overflowY = 'unset'
        setLoader(false);
    }
    const errorLabel = <Label color="red" pointing="above" />

    return <div className='page'>
            
        <div className='main-div'>
            <div className='main-heading'>
                <img src={brandingImageURL} className="logo-towgrace" />
                
            </div>
            <br></br>
            <div className='title'>
                <h2>Service Agreement</h2>
            </div>
            <br></br>
            <div className='main-heading-content'>
                This Agreement is entered into on {createdAt} by and between {sellerName} (hereby referred to as the “Client”) with an address of {sellerAddress} and {brandingName} with principal headquarters located at 1901 N. Roselle Road, 8th Floor, Schaumburg IL 60195.
            </div>
            <br></br>

            <div >
                <div className='sub-heading'>Services Provided:</div>
            </div>
            <div className='sub-heading-content'>
                <div className='heading'>
                {brandingName} will provide the services enlisted below:
                </div>
                <div className='points'>
                    <div>1. Access to {brandingName} Connect, the online portal, where the Client will be presented with qualified tow buyers on an ongoing basis </div>
                    <div>2. Creation of the Client's branded profile page </div>
                </div>
            </div>

            <div>
                <div className='sub-heading'>Payment, Term, and Termination Policy:</div>
            </div>
            <div className='sub-heading-content sub-heading-content-last'>
                Client agrees to pay {brandingName} a monthly fee of <span className='priceDiv'> &nbsp;${price}&nbsp;</span> and a per tow call fee of <span className='priceDiv'>&nbsp;{commission ? commission + "%" : "$" + referralFee}&nbsp;</span> The term will be month to month.
                This agreement can be terminated at any given time by providing a 72-hour notice prior to the renewal date via email by emailing <a href={`mailto:${sellerProfilePublish}`} target="blank">{sellerProfilePublish} </a>
                Client agrees to pay the service fees list above in this agreement as well as agrees to the Syndafy, Inc <a href='https://dealgrace.com/privacy-policy' target="blank"> Privacy Policy</a> and <a href='https://dealgrace.com/terms-of-use' target="blank"> Terms of Service:</a> This Agreement, and the Terms of Service are together referred to as The “Agreement.”
            </div>
            <Form onValidSubmit={onSubmit} ref={formRef} loading={false} className='form-area'>
               
               <Grid className='signature-grid'>
                    <Grid.Row columns={2}>
                        <Grid.Column computer={8} tablet={16} mobile={16}>
                        <div className='signature-box-heading'>{brandingName}</div>
                            <Grid className='sub-grid'>
                                
                                <Grid.Row columns={1}>
                                    <Grid.Column mobile={16} className='signature-field signature-field-name'><div>Name :</div><Form.Input className='signature-name' name="clientName" readOnly={true} value={companySignatureName}></Form.Input></Grid.Column>
                                    
                                </Grid.Row>
                                <Grid.Row columns={1}>
                                    <Grid.Column mobile={16} className='signature-field'><div>Signature :</div><div className='sigPad company-signature'><img className='company-signature-img' src={brandingSignatureImageURL}></img></div></Grid.Column>

                                    
                                </Grid.Row>
                            </Grid>
                        </Grid.Column>
                        <Grid.Column computer={8} tablet={16} mobile={16}>
                        <div className='signature-box-heading'>{sellerName}</div>
                            <Grid className='sub-grid'>
                                <Grid.Row columns={1}>
                                    <Grid.Column mobile={16} className='signature-field signature-field-name'><div>Name :</div><Form.Input className='signature-name' name="sellerContactName" readOnly={isReadOnly} placeholder={sellerUserName} value={_.isEmpty(sellerContactName) ? sellerUserName : sellerContactName}></Form.Input></Grid.Column>

                                </Grid.Row>
                                <Grid.Row columns={1}>
                                    <Grid.Column computer={16} mobile={16} className='signature-field'><div>Signature :</div>{isReadOnly ? <div className='sigPad company-signature'><img className="client-signature-image" src={signatureImage.URL} /> </div>
                                    : <>
                                    
                                            <div>
                                            <canvas className='canvas-sig-pad' oncontextmenu="return false;" height={88}></canvas>
                                            <div className='btn-reset'><Icon  className='button btnClear' name='undo alternate' onClick={clear}/></div>
                                            </div></>}
                                    </Grid.Column>

                                </Grid.Row>
                            </Grid>
                        </Grid.Column>
                        
                    </Grid.Row>

                </Grid>
            <br /><br />
            
                        <div className='button-container'>
                            { !isReadOnly ? <Button className="button-submit save" active type="submit" >Accept & Sign</Button>: '' }
                            
                        </div>
                    
        </Form>

            

        </div>
        {showLoader ? <Dimmer active>
                <Loader indeterminate size='massive' />
            </Dimmer> : ''}
    </div>

}
function mapStateToProps({ seller , reducer}) {
    //Whatever is returned from this function will end up
    // as props inside of this container component
    return {
        seller: seller,
        isTOSEnabled : reducer.isTOSEnabled
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setTOSSigned
    }, dispatch);
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TermsOfService));